(function () {
	"use strict";

	const stickyNav = document.querySelector(".js-navbar");
	if (stickyNav !== null) {
		const stickyNavTop = 10;

		const stickyNavCal = function () {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop >= stickyNavTop) {
				stickyNav.classList.add("sticky");
			} else {
				stickyNav.classList.remove("sticky");
			}
		};

		window.addEventListener("scroll", stickyNavCal);

		stickyNavCal();
	}

	if (document.querySelectorAll('.js-anchor-menu-wrapper').length > 0) {
		const anchorArray = {};
		let i = 1;
		const navbarAnchor = document.querySelector('.js-anchor-menu');
		const navbarAnchorWrapper = document.querySelector('.js-anchor-menu-wrapper');
		const navbarOffset = document.querySelector('.js-navbar').offsetHeight + document.querySelector('.page-header').offsetHeight - 30;
		const stickyWidth = document.querySelector('.js-col').offsetWidth - 32; //minus padding
		const stickyNavAnchorTop = navbarAnchor.offsetTop;
		const containerDiv =
			document.querySelector('.block-article-with-menu').offsetTop +
			document.querySelector('.block-article-with-menu').offsetHeight;

		document.querySelectorAll('.block-article-with-menu').forEach((article) => {
			article.querySelectorAll('.block-article-content').forEach((content) => {
				const attr = content.getAttribute('data-anchor');
				if (typeof attr !== typeof undefined && attr !== false) {
					anchorArray[i] = {
						id: content.getAttribute('id'),
						title: content.getAttribute('data-title'),
					};
					i++;
				}
			});
		});

		Object.values(anchorArray).forEach((anchor) => {
			navbarAnchor.innerHTML += `<li><a class="anchor-menu-item" href="#${anchor.id}">${anchor.title}</a></li>`;
		});

		const stickyAnchorNav = () => {
			const navbarAnchorParent = navbarAnchorWrapper.parentElement;
			const scrollNavBottom = window.pageYOffset + navbarAnchorParent.offsetHeight;
			const containerBottom = containerDiv + navbarOffset - 120;

			if (window.pageYOffset > navbarOffset) {
				if (window.innerWidth > 992) {

					navbarAnchorParent.style.width = `${stickyWidth}px`;
					navbarAnchorParent.classList.add('sticky');
					navbarAnchorParent.classList.remove('sticky-no-top');

					//menu on bottom of div
					if (scrollNavBottom > containerBottom) {
						navbarAnchorParent.classList.remove('sticky');
						navbarAnchorParent.classList.add('sticky-no-top');
					}
				}
			} else {
				navbarAnchorParent.classList.remove('sticky');
				navbarAnchorParent.classList.remove('sticky-no-top');
			}
		};
		stickyAnchorNav();

		window.addEventListener('scroll', () => {
			stickyAnchorNav();
		});

		window.addEventListener('resize', () => {
			stickyAnchorNav();
		});

	}

	//scroll animation anchor link
	const scrollLinks = document.querySelectorAll('a[href^="#"]');
	scrollLinks.forEach(link => {
		link.addEventListener('click', function (event) {
			event.preventDefault();

			//skip faq links
			const attr = link.getAttribute('data-bs-toggle');
			if (attr !== 'collapse') {
				const targetId = link.getAttribute('href').substr(1);
				const target = document.getElementById(targetId);

				if (target) {
					const headerHeight = document.querySelector('.js-navbar').offsetHeight;
					const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

					window.scrollTo({
						top: targetPosition,
						behavior: 'smooth'
					});

				};
			}
		});
	});


	const heroSwipers = document.querySelectorAll('.hero-slider .swiper');
	if (heroSwipers.length > 0) {
		heroSwipers.forEach(function (slider) {
			const swiper_id = slider.getAttribute('id');
			
			// Initialize Swiper with correct configuration
			const heroSwiper = new Swiper('#' + swiper_id, {
				loop: false,
				slidesPerView: 2,
				speed: 600,
				autoplay: {
					delay: 3000,
					disableOnInteraction: true,
					pauseOnMouseEnter: true,
				},
				effect: 'slide',
				pagination: {
					el: '#' + swiper_id + ' .swiper-pagination',
					type: 'bullets',
					clickable: true,
				},
			});
		});
	}

	const recenteBoekenSwipers = document.querySelectorAll('.recent-book-slider .swiper');
	if (recenteBoekenSwipers.length > 0) {
		recenteBoekenSwipers.forEach(function (slider) {
			const swiper_id = slider.getAttribute('id');
			const recenteBoekenSwiper = new Swiper('#' + swiper_id, {
				loop: false,
				slidesPerView: 2,
				speed: 600,
				autoplay: {
					delay: 3000,
					disableOnInteraction: true,
					pauseOnMouseEnter: true,
				},

				//pagination
				pagination: {
					el: '#' + swiper_id + ' .swiper-pagination',
					type: 'bullets',
					clickable: true,
				},

				breakpoints: {
					768: {
						slidesPerView: 3,
					},
					992: {
						slidesPerView: 4,
					},
					1024: {
						slidesPerView: 5,
					}
				}
			});
		});
	}

	//radio buttons for variations
	document.addEventListener('change', (e) => {
		if (!e.target.matches('.balans-variation-radios input')) return;

		// for each checked radio button we reflect the same changes to select dropdowns
		document.querySelectorAll('.balans-variation-radios input:checked').forEach((element) => {
			const radio = element;
			const radioName = radio.getAttribute('name');
			const radioValue = radio.getAttribute('value');
			const select = document.querySelector(`select[name="${radioName}"]`);
			select.value = radioValue;
			select.dispatchEvent(new Event('change', { bubbles: true }));
		});
	});


	const searchFormNav = document.querySelector('.searchform-nav #searchsubmit');
	if (searchFormNav) {
		searchFormNav.addEventListener('click', function (e) {
			//open form instead of submit
			const formSelector = this.closest('#searchform-nav');
			if (!formSelector.classList.contains('show')) {
				e.preventDefault();
				formSelector.classList.add('show');
				formSelector.querySelector('input.field').focus();
				this.setAttribute('aria-expanded', 'true');
			} else if (!formSelector.querySelector('input.field').value) {
				e.preventDefault();
			}
		});
	}

	// Wait for variations to be loaded
	const variationsForm = document.querySelector('.variations_form');
	if (variationsForm) {
		// Run when page is loaded and variations form exists
		const form = variationsForm;

		// Check if no variation is selected
		if (!document.querySelector('.balans-variation-radios input[type="radio"]:checked')) {
			// Select first available variation
			const firstRadio = document.querySelector('.balans-variation-radios input[type="radio"]:first-of-type');
			firstRadio.checked = true;

			// Trigger WooCommerce variation select
			const attributeName = firstRadio.getAttribute('name');
			const value = firstRadio.value;
			const select = document.querySelector(`select[name="${attributeName}"]`);
			select.value = value;
			select.dispatchEvent(new Event('change', { bubbles: true }));

			// Trigger WooCommerce price update
			form.dispatchEvent(new Event('check_variations'));
			form.dispatchEvent(new Event('woocommerce_variation_select_change'));
		}
	}

})();
